import { styled, DialogActions } from '@mui/material';

export const AssistantGenerateRoutesDialogByTemplateContentActionsContainer =
  styled(DialogActions)({
    justifyContent: 'space-between',
  });
